module.exports = __webpack_public_path__ + "5dc961eb8ab6d0c32d34b89ec225b781.svg";


//////////////////
// WEBPACK FOOTER
// ./images/modal-close.svg
// module id = CqKQ
// module chunks = 0